export const benefits = [
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/icons/all-services.svg',
    label: 'benefits.all-srvs-one-place',
    chips: [
      'benefits.central-gov',
      'benefits.utility-bills',
      'benefits.state-gov',
    ],
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/icons/all-doc.svg',
    label: 'benefits.all-docs-one-place',
    chips: [
      'benefits.aadhaar',
      'benefits.driving-license',
      'benefits.pan',
      'benefits.vehicle-rc',
      'benefits.and-more-digi',
    ],
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/icons/all-engagement.svg',
    label: 'benefits.all-engagements',
    chips: [
      'benefits.feedback-rating',
      'benefits.notifications',
      'benefits.customer-support',
      'benefits.live-chat',
      // 'benefits.ai-bot',
      'benefits.chatbot',
      'benefits.voicebot'
    ],
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/icons/all-transactions.svg',
    label: 'benefits.all-transactions',
    chips: [
      'benefits.status',
      'benefits.bills',
      'benefits.applications',
      'benefits.many-more',
    ],
  },
];
